import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { SecondaryButton, TransparentBgButton } from 'components/Shared/Button'
import { getAdsManagerUrl } from './testCampaignUtils'

export default function SuccessView({ campaign, onClose, onRunAnother }) {
  const { t } = useTranslation()

  const adsManagerUrl = campaign.campaign_id
    ? getAdsManagerUrl(campaign.ad_account_id, campaign.campaign_id)
    : null

  return (
    <div className="test-campaign-success">
      <div className="test-campaign-success__content">
        <div className="test-campaign-success__header">
          <h3>
            {t(
              'Settings.MetaAccess.TestCampaign.successTitle',
              'Test Campaign Created Successfully!',
            )}
          </h3>
        </div>

        {(campaign.campaign_name || campaign.campaign_id) && (
          <div className="test-campaign-success__detail">
            <label className="mb-0">
              {t('Settings.MetaAccess.TestCampaign.campaignDetails', 'Campaign Details')}
            </label>
            <div className="test-campaign-success__detail-value">
              {campaign.campaign_name && adsManagerUrl && (
                <a
                  href={adsManagerUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="campaign-name-link"
                  style={{
                    color: '#2F80ED',
                    display: 'inline-block',
                    textDecoration: 'underline',
                  }}
                >
                  {campaign.campaign_name}
                </a>
              )}
              {campaign.campaign_name && !adsManagerUrl && <span>{campaign.campaign_name}</span>}
              {campaign.campaign_name && campaign.campaign_id && (
                <span className="separator"> • </span>
              )}
              {campaign.campaign_id && <span className="campaign-id">{campaign.campaign_id}</span>}
            </div>
          </div>
        )}

        {campaign.assets && (
          <div className="test-campaign-success__assets">
            <label>{t('Settings.MetaAccess.TestCampaign.assetsUsed', 'Meta Assets Used')}</label>
            <div className="test-campaign-success__assets-list">
              {campaign.ad_account_id && (
                <div className="test-campaign-success__asset-item">
                  <span className="asset-label">
                    {t('Settings.MetaAccess.TestCampaign.adAccount', 'Ad Account')}:
                  </span>
                  <span className="asset-value">{campaign.ad_account_id}</span>
                </div>
              )}
              {campaign.assets.profile_id && (
                <div className="test-campaign-success__asset-item">
                  <span className="asset-label">
                    {t('Settings.MetaAccess.TestCampaign.page', 'Page')}:
                  </span>
                  <span className="asset-value">{campaign.assets.profile_id}</span>
                </div>
              )}
              {campaign.assets.instagram_user_id && (
                <div className="test-campaign-success__asset-item">
                  <span className="asset-label">
                    {t('Settings.MetaAccess.TestCampaign.instagram', 'Instagram')}:
                  </span>
                  <span className="asset-value">{campaign.assets.instagram_user_id}</span>
                </div>
              )}
              {campaign.assets.pixel_id && (
                <div className="test-campaign-success__asset-item">
                  <span className="asset-label">
                    {t('Settings.MetaAccess.TestCampaign.pixel', 'Pixel')}:
                  </span>
                  <span className="asset-value">{campaign.assets.pixel_id}</span>
                </div>
              )}
            </div>
          </div>
        )}

        <div className="test-campaign-success__info">
          <span className="test-campaign-success__info-text text-left">
            {t(
              'Settings.MetaAccess.TestCampaign.successNote',
              // eslint-disable-next-line quotes
              "If you see any issues in Ads Manager, follow Meta's recommendations to resolve them.",
            )}
          </span>
        </div>
      </div>

      <div className="test-campaign-success__footer">
        <div className="d-flex gap-2 w-100 justify-content-between">
          <TransparentBgButton
            text={t('common.close', 'Close')}
            onClick={onClose}
            color="navy"
            fullWidth
          />
          <SecondaryButton
            className="bt"
            text={t('Settings.MetaAccess.TestCampaign.runAnother', 'Run Another')}
            fullWidth
            onClick={onRunAnother}
          />
        </div>
      </div>
    </div>
  )
}

SuccessView.propTypes = {
  campaign: PropTypes.shape({
    campaign_id: PropTypes.string,
    campaign_name: PropTypes.string,
    ad_account_id: PropTypes.string.isRequired,
    assets: PropTypes.shape({
      profile_id: PropTypes.string,
      instagram_user_id: PropTypes.string,
      pixel_id: PropTypes.string,
    }),
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onRunAnother: PropTypes.func.isRequired,
}
